import React, { useEffect, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import { client } from '../../puraearth/src/services/Moltin'
import agingBlack from '../../images/aging-black.svg'
import agingBlue from '../../images/aging-blue.svg'
import agingGreen from '../../images/aging-green.svg'
import wrinkleBlack from '../../images/wrinkle-black.svg'
import wrinkleBlue from '../../images/wrinkle-blue.svg'
import wrinkleGreen from '../../images/wrinkle-green.svg'
import longevityBlack from '../../images/longevity-black.svg'
import longevityBlue from '../../images/longevity-blue.svg'
import longevityGreen from '../../images/longevity-green.svg'
import vitalityBlack from '../../images/vitality-black.svg'
import vitalityBlue from '../../images/vitality-blue.svg'
import vitalityGreen from '../../images/vitality-green.svg'
import { FormattedMessage } from 'react-intl'

const localeToCurrencyConsts = require('../../constants/localeCurrencyConsts')
const localeConsts = require('../../constants/localeConsts')
const useStyles = makeStyles(theme => {
  return {
    mainContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(8)
    },
    title: {
      marginBottom: theme.spacing(4)
    },
    benefitsWrapper: {
      width: 624,
      [theme.breakpoints.down('md')]: {
        width: '100vw',
        maxWidth: 624,
        padding: 0
      }
    },
    benefitsItem: {
      alignItems: 'center',
      display: 'flex',
      fontSize: 20,
      fontFamily: theme.typography.fontFamily,
      listStyle: 'none',
      marginBottom: theme.spacing(0.25),
      minHeight: 104,
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(15),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.spacing(2)
      },
      backgroundPosition: theme.spacing(4),
      backgroundRepeat: 'no-repeat',
      backgroundSize: theme.spacing(7)
    },
    agingBenefitBackground: {
      backgroundImage: ({ color }) => {
        const aging = {
          black: agingBlack,
          blue: agingBlue,
          green: agingGreen
        }
        return `url(${aging[color]})`
      },
      backgroundColor: ({ color }) =>
        color === 'black'
          ? theme.palette[color].supportLightBackground
          : theme.palette[color].support
    },
    wrinkleBenefitBackground: {
      backgroundImage: ({ color }) => {
        const wrinkle = {
          black: wrinkleBlack,
          blue: wrinkleBlue,
          green: wrinkleGreen
        }
        return `url(${wrinkle[color]})`
      },
      backgroundColor: ({ color }) =>
        color === 'black'
          ? theme.palette[color].supportLightBackground
          : theme.palette[color].support

    },
    longevityBenefitBackground: {
      backgroundImage: ({ color }) => {
        const longevity = {
          black: longevityBlack,
          blue: longevityBlue,
          green: longevityGreen
        }
        return `url(${longevity[color]})`
      },
      backgroundColor: ({ color }) =>
        color === 'black'
          ? theme.palette[color].supportLightBackground
          : theme.palette[color].support
    },
    vitalityBenefitBackground: {
      backgroundImage: ({ color }) => {
        const vitality = {
          black: vitalityBlack,
          blue: vitalityBlue,
          green: vitalityGreen
        }
        return `url(${vitality[color]})`
      },
      backgroundColor: ({ color }) =>
        color === 'black'
          ? theme.palette[color].supportLightBackground
          : theme.palette[color].support
    }
  }
})

function isEmpty (str) {
  return str && !str.isEmpty
}

const useBenefits = (header, productId, locale) => {
  const [benefits, setBenefits] = useState([])
  useEffect(() => {
    ;(async () => {
      const benefitsData = await client
        .get(`products/${productId}`, header)
        .then(product => {
          const benefits = []
          for (let i = 1; i <= 6; i++) {
            benefits.push({
              text: product.data[`benefit${i}${locale}`],
              image: product.data[`benefitImage${i}`]
            })
          }
          return benefits.filter(benefit => isEmpty(benefit.text) && isEmpty(benefit.image))
        })
      setBenefits(benefitsData)
    })()
  }, [])
  return benefits
}

export default ({ locale, productId, color }) => {
  const classes = useStyles({ color })
  const header = {
    'X-Moltin-Language': localeConsts.moltinLanguageCode[locale],
    'X-Moltin-Currency': localeToCurrencyConsts[locale]
  }
  const benefits = useBenefits(header, productId, localeConsts.moltinLanguageCode[locale])
  if (benefits.length === 0) return (null)

  return (
    <div className={classes.mainContainer} >
      <Typography className={classes.title} variant={'h4'} component={'h4'}>
        <FormattedMessage id='benefits' />
      </Typography>
      <ul className={classes.benefitsWrapper}>
        { benefits.map((benefit, index) => {
          const backgroundBenefitImage = classes[`${benefit.image}BenefitBackground`]
          return (
            <li key={index} className={`${classes.benefitsItem} ${backgroundBenefitImage}`}>
              { benefit.text }
            </li>
          )
        })
        }
      </ul>
    </div>
  )
}
